

export default {
  name: 'sup-tasks',
  components: {
  },
  created() {

    let t = this;

    t.loadTask();

  },
  activated() {

    let t = this;

  },
  methods: {

    prevDay() {

      let t = this;

      let d = new Date(t.currentDate);

      d.setDate(d.getDate() - 1);

      t.currentDate = d;

      t.loadTask();

    },

    nextDay() {

      let t = this;

      let d = new Date(t.currentDate);

      d.setDate(d.getDate() + 1);

      t.currentDate = d;

      t.loadTask();

    },

    loadTask() {

      let t = this;

      //读取今日清扫房间


      let p = {
        '_with': 'room,sup',
        'date': t.currentDate.format('yyyy-MM-dd'),
        '_withNextTask': t.currentDate.format('yyyy-MM-dd'),
        '_all': 1,
        'sup_employee_id': t.U.id
      };

      axios.get('cleanTask', { params: p }).then(res => {

        if (res.data.status == 1) {

          let arr = res.data.options.items;

          t.list.room.clear();

          arr.forEach(item => {

            if (!item.sup) {
              item.sup = {
                color: 1,
                bath: 0,
                toilet: 0,
                king: 0,
                queen: 0,
                double: 0,
                single: 0,
                remark: '',
                employee_id: null,
                task_id: item.id
              };
              if (item.next_order) {
                item.sup.king = item.next_order.k || 0;
                item.sup.queen = item.next_order.q || 0;
                item.sup.double = item.next_order.d || 0;
                item.sup.single = item.next_order.s || 0;
              }
            }

            if (item.next_task && !item.next_task.sup) {
              item.next_task.sup = {
                color: 1,
                bath: 0,
                toilet: 0,
                king: 0,
                queen: 0,
                double: 0,
                single: 0,
                remark: '',
                employee_id: null,
                task_id: item.next_task.id
              };

              if (item.next_task.next_order) {
                item.next_task.sup.king = item.next_task.next_order.k || 0;
                item.next_task.sup.queen = item.next_task.next_order.q || 0;
                item.next_task.sup.double = item.next_task.next_order.d || 0;
                item.next_task.sup.single = item.next_task.next_order.s || 0;
              }
            }

            if (item.room) {
              item.room.task = item;
            }
          });

          arr = arr.sort((a, b) => {
            return (a.sup.id || 0) - (b.sup.id || 0);
          });

          t.ready = true;

          t.dict.room = listToDict(t.list.room);

          t.list.cleanTask = arr;

        }
      });

    },

    markDone(item) {
      let t = this;

      if (t.currentDate.format('yyyy-MM-dd') != Date.today().format('yyyy-MM-dd')) {
        A.err('当日のタスクではありませんが、完了できません。');
        return;
      }

      if (t.busying)
        return;

      t.busying = true;

      axios.put('cleanTaskSup/' + item.id, { 'status': 1 }).then(res => {

        t.busying = false;

        if (res.data.status == 1) {
          item.status = 1;
        }
      });

    }

  },
  data() {
    return {
      ready: false,
      minDate: new Date('2024/01/01'),
      today: Date.today(),
      currentDate: Date.today(),
      list: {
        room: [],
        cleanTask: [],
      },
      dict: {
        cleanTask: {},
      },
    };
  },
  computed: {
  }
};
